import { render, staticRenderFns } from "./UsersEdit.vue?vue&type=template&id=06963d9e&scoped=true"
import script from "./UsersEdit.vue?vue&type=script&lang=js"
export * from "./UsersEdit.vue?vue&type=script&lang=js"
import style0 from "./UsersEdit.vue?vue&type=style&index=0&id=06963d9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06963d9e",
  null
  
)

export default component.exports